<template>
    <div class="success-main__content">
        <div class="success-main__top" >
            <div class="success-main__pic">
                <img src="@/assets/images/success/success.svg" alt="">
            </div>
            <div class="success-main__title title-h3">
                {{ $t("success.account-activation.title") }}
            </div>
            <div class="success-main__subtitle font-reg">
                {{ $t("success.account-activation.subtitle") }}
            </div>
        </div>
        <div class="success-main__action">
            <button class="btn btn-sm btn-gradient" @click="login">
                <span>{{ $t("form.login") }}</span>
            </button>
        </div>
    </div>
</template>

<script>
    export default {
        methods: {
            login() {
                this.$router.push('/members/sign-in')
            },
            async confirm(code) {
                try {
                    await this.$store.dispatch('ACTIVATE_ACCOUNT', {confirmation_code: code})
//                    this.login()
                }catch(e) {
                    console.log(e.response, 'hello world')
                }
            },
        },
        created() {
            if(this.$route.query && this.$route.query.activation_code) {
                let {activation_code} = this.$route.query
                this.confirm(activation_code)
            } else {
                this.login()
            }
        }
    }
</script>